import React, { useEffect, useState } from "react";
import "./QuestionType.css";
import CheckBoxType from "./CheckBoxType";
import CheckBoxTypeSA from "../../../SelfAssessment/Completed/CheckBoxType";
import SucessfullySubmited from "./SucessfullySubmited";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SuccessfullyUpdatedAssessement from "../../../SelfAssessment/Popup/SuccessfullyUpdatedAssessement";
import AllQuestionRequired from "../../../SelfAssessment/Popup/AllQuestionRequired";
import {
  assessmentTimeHelper,
  assessmentDateHelper,
} from "../../../../utils/datetime_helper";
import FailedApiPopup from "../../Completed/QuestionCompleted/FailedApiPopup";

export default function AllQuestions({ type }) {
  const { assessmentId, selfAssessmentId } = useParams();
  const [pendingData, setPendingData] = useState([]);
  const location = useLocation();
  const state = location.state;
  const [studentResponse, setStudentResponse] = useState();
  const [responseAnswers, setResponseAnswers] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [questionsAnswer, setQuestionsAnswer] = useState([]);
  const [currencyQuestionAnswer, setCurrentQuestionAnswer] = useState(null);
  const [questionNo, setQuestionNo] = useState(0);
  const [selfAssessmentUpdated, setSelfAssessmentUpdated] = useState(false);
  const [isNotAllQuestionAnswered, setIsNotAllQuestionAnswered] =
    useState(false);
  const [allQuestions, setAllQuestions] = useState([]);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [failedApiPopup, setFailedApiPopup] = useState(false);
  const [isNextQuestion, setIsNextQuestion] = useState(false);

  const [allQuestion, setAllQuestion] = useState({ sucessful: false });
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const navigate = useNavigate();

  // ===== API (unchanged) =====
  const getStudentResponse = async () => {
    try {
      let res = await axios.get(
        `assessment/${state.assessmentId}/studentResponse/student/${userId}/get`,
      );
      res && setStudentResponse(res.data.data);
      setIsGettingData(false);
      setResponseAnswers(res?.data?.data?.answers);
    } catch (error) {
      setFailedApiPopup(true);
      setIsGettingData(false);
      console.log(error);
    }
  };

  const getSAQuestionResponse = async () => {
    try {
      let updatedQuestion = [];
      let tempAllQuestion = [];
      let res = await axios.get(`/selfAssess/get/${state.selfAssessmentId}`);
      if (
        res.data.data?.questions.length == 0 &&
        res.data.data?.b4sQuestions.length == 0
      ) {
        toast.info("Qustions not available");
        navigate(-1);
        return false;
      } else {
        res &&
          res.data.data?.questions.forEach((question, index) => {
            tempAllQuestion.push(question);
            if (!question.type.is_manually_graded) {
              updatedQuestion.push({
                question_id: question?.id,
                questionSource: "question",
                options: { key: " ", explanation: " " },
                mandatory: question?.is_mandatory,
                index,
              });
            } else {
              updatedQuestion.push({
                question_id: question?.id,
                questionSource: "question",
                description: " ",
                attachments: [],
                mandatory: question?.is_mandatory,
                index,
              });
            }
          });
        res.data.data?.b4sQuestions.forEach((question, index) => {
          tempAllQuestion.push(question);
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              question_id: question?.id,
              questionSource: "b4s",
              options: { key: " ", explanation: " " },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              question_id: question?.id,
              questionSource: "b4s",
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
        setAllQuestions(tempAllQuestion);
        res && setPendingData([...updatedQuestion]);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getSAAnswerResponse = async () => {
    try {
      let res = await axios.get(
        `selfAssess/${state.selfAssessmentId}/studentResponse/student/${userId}/get`,
      );
      res && setStudentResponse(res.data.data);
      setIsGettingData(false);
      setResponseAnswers(res?.data?.data?.answers);
      setCurrentQuestionAnswer(res?.data?.data?.answers[questionNo]);
      setQuestionsAnswer([...res?.data?.data?.answers]);
    } catch (error) {
      setFailedApiPopup(true);
      setIsGettingData(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (type == "SA" || state.type == "SA") {
      getSAQuestionResponse();
      getSAAnswerResponse();
    } else {
      getStudentResponse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, type, state?.type]);

  const timeHelper = (a) => {
    if (!a) return null;
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000;
    const localDate = new Date(dateObj - userOffset);
    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleSubmit = async () => {
    try {
      setDisableSubmitButton(true);
      setIsLoading(true);
      let qustionAnswer = [];
      let b4sQuestionAnswer = [];

      questionsAnswer.length > 0 &&
        questionsAnswer.forEach((answer) => {
          if (answer?.b4sQuestion) {
            b4sQuestionAnswer?.push({
              id: answer?.id,
              question_id: answer?.b4sQuestion.id,
              answer: answer?.answer,
            });
          } else {
            qustionAnswer.push({
              id: answer.id,
              question_id: answer.question.id,
              answer: answer.answer,
            });
          }
        });

      let selfAssessmentBody = {
        student_id: userId,
        submitted_on: new Date(),
        questionanswers: qustionAnswer,
        b4squestionanswers: b4sQuestionAnswer,
      };

      let notAnswer =
        questionsAnswer.length > 0 &&
        questionsAnswer.filter((answer) => answer.answer.key == " ");

      if (notAnswer.length > 0) {
        setIsNotAllQuestionAnswered(true);
        setIsLoading(false);
        setDisableSubmitButton(false);
        return;
      }

      let res = await axios.post(
        `/selfAssess/${state.selfAssessmentId}/studentResponse/update`,
        selfAssessmentBody,
      );
      setSelfAssessmentUpdated(true);

      if (res) {
        setIsLoading(false);
        setAllQuestion({ ...allQuestion, sucessful: true });
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    } finally {
      setDisableSubmitButton(false);
    }
  };

  const handleSucessfulyfalse = () => {
    setAllQuestion({ ...allQuestion, sucessful: false });
  };

  const questionType =
    responseAnswers[questionNo]?.b4sQuestion?.type?.type ||
    responseAnswers[questionNo]?.question?.type?.type;

  // ================= LOADING =================
  if (isGettingData) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
        <div className="bg-white p-6 rounded-xl shadow-xl">
          <img
            className="w-16 h-16"
            src="/gif/LoaderDot.gif"
            alt="Loading..."
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {/* FULL SCREEN MODAL WRAPPER */}
      <div className="fixed inset-0 z-[9999] bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-2 md:p-6 overflow-hidden">
        <div className="bg-[#f5f7fa] w-full max-w-[1400px] h-full max-h-[95vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden">
          {/* =========================================
              FIXED HEADER SECTION (No Scroll)
             ========================================= */}
          <div className="shrink-0 bg-white border-b border-slate-200 px-5 py-4 md:px-6 md:py-5 rounded-t-2xl">
            {/* Row 1: Back + Breadcrumb + Tags  */}
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div className="flex items-center gap-2 flex-wrap text-[15px]">
                <button
                  onClick={() => window.history.back()}
                  className="text-slate-500 hover:text-red-500 hover:bg-red-50 p-1 -ml-2 rounded-lg transition-colors focus:outline-none"
                  title="Close"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M18 6L6 18M6 6L18 18"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                <span className="text-slate-500 font-medium">Assessment</span>
                <span className="text-slate-300">/</span>
                <span className="font-bold text-slate-800">
                  {type == "SA"
                    ? studentResponse?.selfAssess?.name
                    : studentResponse?.assessment?.name}
                </span>
                <span className="text-slate-300 mx-0.5">|</span>
                <span className="text-slate-500 font-medium text-sm">
                  {studentResponse?.student?.name || "Student"}
                </span>

                {/* Auto Evaluated badge */}
                <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-[11px] font-semibold">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 2L14.5 9H21L15.5 13L17.5 20L12 16L6.5 20L8.5 13L3 9H9.5L12 2Z"
                      fill="currentColor"
                    />
                  </svg>
                  Auto Evaluated
                </span>

                {/* Completed badge */}
                <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-emerald-600 text-white text-[11px] font-semibold">
                  <span className="w-1.5 h-1.5 rounded-full bg-white/90" />
                  On Review
                </span>
              </div>
            </div>

            {/* Row 2: Assessment title */}
            {studentResponse?.assessment?.description && (
              <p className="mt-3 mb-0 text-[14px] text-slate-600">
                {studentResponse?.assessment?.description}
              </p>
            )}

            {/* Row 3: Scheduled meta */}
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-3 text-[13px]">
              <span className="inline-flex items-center gap-1.5">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="text-slate-400"
                >
                  <rect
                    x="3"
                    y="5"
                    width="18"
                    height="16"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M8 3V7M16 3V7M3 11H21"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span className="text-slate-500 font-medium">Scheduled</span>
                <span className="font-semibold text-slate-700">
                  {assessmentDateHelper(
                    studentResponse?.assessment?.schedule_date,
                  )}
                  {" - "}
                  {assessmentTimeHelper(
                    studentResponse?.assessment?.schedule_time,
                  )}
                </span>
              </span>

              <span className="hidden sm:inline text-slate-300">|</span>

              <span className="inline-flex items-center gap-1.5">
                <span className="text-slate-500 font-medium">Submitted</span>
                <span className="font-semibold text-slate-700">
                  {timeHelper(studentResponse?.submitted_on)}
                </span>
              </span>

              <span className="hidden sm:inline text-slate-300">|</span>

              <span className="inline-flex items-center gap-1.5">
                <span className="text-slate-500 font-medium">Total Marks</span>
                <span className="font-semibold text-slate-700">
                  {type == "SA"
                    ? studentResponse?.selfAssess?.total_marks
                    : studentResponse?.assessment?.total_marks}
                </span>
              </span>

              <span className="hidden sm:inline text-slate-300">|</span>

              <span className="inline-flex items-center gap-1.5">
                <span className="text-slate-500 font-medium">Questions</span>
                <span className="font-semibold text-slate-700">
                  {questionNo + 1}/{studentResponse?.answers?.length}
                </span>
              </span>
            </div>
          </div>

          {/* =========================================
              SCROLLABLE CONTENT SECTION
             ========================================= */}
          <div className="flex-1 overflow-y-auto p-3 md:p-5 custom-scrollbar">
            <div className="max-w-[1400px] mx-auto flex flex-col gap-4">
              {/* ============ NAVIGATOR CARD ============ */}
              <div className="bg-white rounded-xl border border-slate-200 shadow-[0_1px_3px_rgba(15,23,42,0.06)] px-5 py-3.5 md:px-6">
                <div className="flex items-center justify-between gap-3 flex-wrap">
                  {/* Question pills */}
                  <div className="flex items-center gap-2 overflow-x-auto pb-1 flex-1 min-w-0 aq-nav-scroll">
                    {responseAnswers?.length > 0 &&
                      responseAnswers?.map((item, index) => {
                        const isCurrent = questionNo === index;
                        const isCompleted = questionNo > index;
                        return (
                          <button
                            key={index}
                            onClick={() => {
                              setQuestionNo(index);
                              setCurrentQuestionAnswer(questionsAnswer[index]);
                            }}
                            className={[
                              "relative flex-shrink-0 min-w-[44px] h-10 px-3 rounded-lg border-[1.5px] text-sm font-semibold transition-all",
                              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-1",
                              isCurrent
                                ? "border-orange-400 bg-orange-50 text-orange-600 shadow-sm"
                                : isCompleted
                                  ? "border-orange-300 bg-orange-50/40 text-orange-500 hover:border-orange-400 hover:-translate-y-0.5"
                                  : "border-slate-200 bg-white text-slate-500 hover:border-orange-300 hover:text-orange-500 hover:-translate-y-0.5",
                            ].join(" ")}
                            aria-label={`Go to question ${index + 1}${item.is_mandatory ? " (mandatory)" : ""}`}
                            aria-current={isCurrent ? "step" : undefined}
                          >
                            Q{index + 1}
                            {item.is_mandatory && (
                              <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-red-600 border-2 border-white" />
                            )}
                          </button>
                        );
                      })}
                  </div>

                  {/* Prev / Next */}
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <button
                      onClick={() => setQuestionNo(questionNo - 1)}
                      disabled={questionNo < 1}
                      className="inline-flex items-center gap-1.5 px-4 py-2 bg-white border border-orange-300 rounded-lg text-sm font-semibold text-orange-500 transition-all hover:bg-orange-50 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-1"
                    >
                      Previous
                    </button>

                    {responseAnswers?.length > questionNo + 1 ? (
                      <button
                        onClick={() => {
                          setQuestionNo(questionNo + 1);
                          setCurrentQuestionAnswer(questionsAnswer[questionNo]);
                          setIsNextQuestion((prev) => !prev);
                        }}
                        className="inline-flex items-center gap-1.5 px-5 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-semibold shadow-sm shadow-orange-500/30 transition-all hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-1"
                      >
                        Next
                      </button>
                    ) : type == "SA" ? (
                      <button
                        disabled={disableSubmitButton}
                        onClick={handleSubmit}
                        className="inline-flex items-center gap-1.5 px-5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-semibold shadow-sm shadow-emerald-600/30 transition-all hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-1"
                      >
                        {isLoading ? "Submitting..." : "Submit"}
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* ============ QUESTION CONTENT CARD ============ */}
              <div className="bg-white rounded-xl border border-slate-200 shadow-[0_1px_3px_rgba(15,23,42,0.06)] px-5 py-5 md:px-7 md:py-6 mb-2">
                {type === "SA" ? (
                  questionType === "multiple choice" ||
                  questionType === "MCQ" ? (
                    <CheckBoxTypeSA
                      type={type}
                      responseAnswers={currencyQuestionAnswer}
                      questionNo={questionNo + 1}
                      questionsAnswer={questionsAnswer}
                      setQuestionsAnswer={setQuestionsAnswer}
                      isNextQuestion={isNextQuestion}
                    />
                  ) : (
                    <SubmisshionByUpload
                      questionNo={questionNo + 1}
                      response={responseAnswers[questionNo]}
                    />
                  )
                ) : !responseAnswers[questionNo]?.question?.type
                    ?.is_manually_graded ? (
                  <CheckBoxType
                    type={type}
                    responseAnswers={currencyQuestionAnswer}
                    questionNo={questionNo + 1}
                    response={responseAnswers[questionNo]}
                    setQuestionsAnswer={setQuestionsAnswer}
                  />
                ) : (
                  <SubmisshionByUpload
                    questionNo={questionNo + 1}
                    response={responseAnswers[questionNo]}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Popups */}
      {allQuestion.sucessful && (
        <SucessfullySubmited handleSucessfulyfalse={handleSucessfulyfalse} />
      )}
      {selfAssessmentUpdated && (
        <SuccessfullyUpdatedAssessement
          setSelfAssessmentUpdated={setSelfAssessmentUpdated}
        />
      )}
      {isNotAllQuestionAnswered && (
        <AllQuestionRequired
          setIsNotAllQuestionAnswered={setIsNotAllQuestionAnswered}
        />
      )}
      {failedApiPopup && <FailedApiPopup onReview={"onReview"} />}
      {isLoading && (
        <div className="fixed inset-0 bg-white/75 backdrop-blur-sm flex items-center justify-center z-[9999]">
          <img
            className="ongoing_internal_loader-self-ass"
            src="/gif/LoaderDot.gif"
            alt="Loading..."
          />
        </div>
      )}
    </>
  );
}
